<script setup>
import { validationCheck } from '@utils'

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useServiceItem } from '@store/serviceItem'
const $serviceItem = useServiceItem()

import { useRouter } from 'vue-router'
const router = useRouter()

import Main from './Main.vue'
// import BusinessProfileInformation from '../settings/BusinessProfileInformation.vue'
import EditStaff from '@views/service/EditStaff.vue'
import ButtonBack from './ButtonBack.vue'
import ButtonNext from './ButtonNext.vue'

const saveServiceStaff = () => {

    // validation
    let { errors } = validationCheck([
        {
            condition: $serviceItem.service.staffs.length === 0,
            message: `${$settings.labels.service?.singular} must have at least one ${String($settings.labels.staff?.singular).toLowerCase()}`
        },
    ])
    if (errors) return


    router.push({ name: 'onboarding.service.duration' })
}
</script>

<template>
    <Main :title="`Assign ${$settings.labels.staff?.singular}`" :progress="66">
        <EditStaff />

        <div class="flex gap-10 mt-5">
            <ButtonBack text="Prev" @click="router.push({ name: 'onboarding.service.general' })" />
            <ButtonNext @click="saveServiceStaff()" />
        </div>

        <template #footer>
            <!-- <ButtonBack text="Prev" @click="router.push({ name: 'onboarding.service.general' })" />
            <ButtonNext @click="saveServiceStaff()" /> -->
        </template>
    </Main>
</template>